import AbstractModel from "../negocio/AbstractModel";

export interface Acesso {
  tela: string;
  visualizacao: boolean;
  alteracao: boolean;
}

export interface Perfil extends AbstractModel {
  guid?: string;
  nome: string;
  descricao?: string;
  ativo: boolean;
  acessos: Acesso[];
}

export interface TelaDisponivel {
  codigo: string;
  nome: string;
  descricao: string;
  categoria: string;
}

// Definição das telas disponíveis no sistema
export const TELAS_DISPONIVEIS: TelaDisponivel[] = [
  // Dashboard e Analytics
  { codigo: 'dashboard', nome: 'Dashboard', descricao: 'Visão geral e métricas', categoria: 'Analytics' },
  { codigo: 'relatorios', nome: 'Relatórios', descricao: 'Geração e visualização de relatórios', categoria: 'Analytics' },
  { codigo: 'insights', nome: 'Insights', descricao: 'Análises e insights do negócio', categoria: 'Analytics' },

  // Gestão de Pessoas
  { codigo: 'colaboradores', nome: 'Colaboradores', descricao: 'Gestão de colaboradores', categoria: 'Pessoas' },
  // { codigo: 'cadastro-colaboradores', nome: 'Cadastro de Colaboradores', descricao: 'Criar e editar colaboradores', categoria: 'Pessoas' },
  { codigo: 'departamentos', nome: 'Departamentos', descricao: 'Gestão de departamentos', categoria: 'Pessoas' },

  // Planejamento Estratégico
  { codigo: 'fundamentos', nome: 'Fundamentos', descricao: 'Definição de fundamentos organizacionais', categoria: 'Estratégia' },
  { codigo: 'diretrizes', nome: 'Diretrizes', descricao: 'Diretrizes estratégicas', categoria: 'Estratégia' },
  { codigo: 'mapa-estrategico', nome: 'Mapa Estratégico', descricao: 'Visualização do mapa estratégico', categoria: 'Estratégia' },
  { codigo: 'swot', nome: 'Análise SWOT', descricao: 'Matriz SWOT', categoria: 'Estratégia' },
  { codigo: 'ambiente-interno', nome: 'Ambiente Interno', descricao: 'Análise do ambiente interno', categoria: 'Estratégia' },
  { codigo: 'ambiente-externo', nome: 'Ambiente Externo', descricao: 'Análise do ambiente externo', categoria: 'Estratégia' },

  // Gestão de Metas e OKRs
  { codigo: 'metas', nome: 'Metas', descricao: 'Gestão de metas', categoria: 'Metas' },
  { codigo: 'meta-global', nome: 'Meta Global', descricao: 'Definição de metas globais', categoria: 'Metas' },
  // { codigo: 'avaliacao-metas-globais', nome: 'Avaliação de Metas Globais', descricao: 'Avaliar metas globais', categoria: 'Metas' },
  { codigo: 'desdobramento', nome: 'Desdobramento', descricao: 'Desdobramento de metas', categoria: 'Metas' },

  // Plano de Ação
  { codigo: 'plano-de-acao', nome: 'Plano de Ação', descricao: 'Gestão do plano de ação', categoria: 'Execução' },
  { codigo: 'avaliacao-plano-de-acao', nome: 'Avaliação do Plano de Ação', descricao: 'Avaliar execução do plano', categoria: 'Execução' },
  { codigo: 'tarefas', nome: 'Tarefas', descricao: 'Gestão de tarefas', categoria: 'Execução' },
  { codigo: 'thinkboard', nome: 'ThinkBoard', descricao: 'Quadro de gestão visual', categoria: 'Execução' },

  // Análises e Avaliações
  { codigo: 'pontos-fortes', nome: 'Pontos Fortes', descricao: 'Identificação de pontos fortes', categoria: 'Análise' },
  { codigo: 'pontos-fracos', nome: 'Pontos Fracos', descricao: 'Identificação de pontos fracos', categoria: 'Análise' },
  // { codigo: 'avaliacao', nome: 'Avaliação', descricao: 'Sistema de avaliações', categoria: 'Análise' },

  // Configurações e Administração
  { codigo: 'perfis', nome: 'Perfis de Acesso', descricao: 'Gestão de perfis de acesso', categoria: 'Administração' },
  { codigo: 'notificacoes', nome: 'Notificações', descricao: 'Sistema de notificações', categoria: 'Administração' },
  { codigo: 'profile', nome: 'Perfil', descricao: 'Perfil do usuário', categoria: 'Administração' },

  // Pagamentos e Assinaturas
  { codigo: 'pagamento', nome: 'Pagamento', descricao: 'Processamento de pagamentos', categoria: 'Comercial' },
  { codigo: 'subscription', nome: 'Assinatura', descricao: 'Gestão de assinaturas', categoria: 'Comercial' }
];